// CP5: smallest-safe state bridge so "Create Buyer Need" from the Refer-a-Client flow can
// hop to the existing Buyer Need creation page and return with the recipient preserved and
// the newly created Buyer Need auto-selected. sessionStorage survives the route change.
const KEY = "referral_resume";

export function saveReferralResume(payload) {
  try { sessionStorage.setItem(KEY, JSON.stringify(payload)); } catch {}
}

export function readReferralResume() {
  try { const v = sessionStorage.getItem(KEY); return v ? JSON.parse(v) : null; } catch { return null; }
}

export function clearReferralResume() {
  try { sessionStorage.removeItem(KEY); } catch {}
}
